import React from "react";

interface TableProps extends React.HTMLAttributes<HTMLTableElement> {
  children: React.ReactNode;
}

export const Table = ({ children, className, ...rest }: TableProps) => {
  return (
    <div className="table-responsive">
      <table
        className={`table table-hover table-outline table-vcenter card-table ${className}`}
        style={{ height: "fit-content" }}
        {...rest}
      >
        {children}
      </table>
    </div>
  );
};
